import * as mwx from '/src/utils/common';
import * as service from '@/utils/service.js';
import { changeDpiDataUrl } from '@/utils/changeDpi';
const maxCanvasWidth = 1999;
let everyRepeatLimitSizeList = [maxCanvasWidth];
const getApp = mwx.getApp;

function initCanvas({ selector, dpr, canvasWidth, canvasHeight }) {
  var canvas = selector
    ? document.querySelector(selector)
    : document.createElement('canvas');
  var context = canvas.getContext('2d');
  dpr = dpr || window.devicePixelRatio || 1; // 获取设备像素比
  canvas.width = canvasWidth * dpr;
  canvas.height = canvasHeight * dpr;
  canvas.style.width = canvasWidth + 'px';
  canvas.style.height = canvasHeight + 'px';
  context.scale(dpr, dpr); // 缩放上下文以匹配分辨率

  return {
    canvas,
    context
  };
}

function _createImage(imageUrl) {
  if (typeof imageUrl != 'string' && mwx.isDev) {
    debugger;
  }
  return new Promise((resolve, reject) => {
    const img = new Image();
    if (/^http/.test(imageUrl)) {
      img.crossOrigin = 'anonymous';
    }
    img.onload = () => {
      resolve(img);
    };
    img.onerror = (err) => {
      console.error(
        'createImage error',
        imageUrl ? imageUrl.slice(0, 300) : ''
      );
      reject(err);
    };
    img.src = imageUrl;
  });
}

function createImage(imageUrl) {
  if (typeof imageUrl != 'string' && mwx.isDev) {
    debugger;
  }
  return mwx
    .repeatPromise({
      promiseCb: () => _createImage(imageUrl),
      repeatCount: 5,
      repeatInterval: 1000
    })
    .catch((r) => {
      console.log('createImage repeat fail', r);
      mwx.getImgErrorCode(imageUrl);
      throw r;
    });
}

async function crop({
  imageSrc,
  cropInfo = {},
  originImageWidth,
  originImageHeight,
  pageSelf
}) {
  let imageInfo = await mwx.getImageInfo(imageSrc);
  cropInfo.angle = 0;
  let max = Math.max(imageInfo.width, imageInfo.height);
  if (cropInfo.angle == 0) {
    // 裁剪矩形区域的最大值
    max = Math.max(cropInfo.rect[2], cropInfo.rect[3]);
  }
  let scaleList = everyRepeatLimitSizeList
    .map((v) => v / max)
    .filter((v) => v <= 1);
  let self = this;
  let originalImageSrc = imageSrc;

  // let limitCreateImageSize = mwx.Store.get('limitCreateImageSize');
  let limitCreateImageSize = 0;
  let repeatCount = 0;
  let maxDrawImageSize = maxCanvasWidth;
  if (
    !limitCreateImageSize &&
    (imageInfo.width > maxDrawImageSize || imageInfo.height > maxDrawImageSize)
  ) {
    limitCreateImageSize = everyRepeatLimitSizeList[0];
  }
  let isOverLimit =
    ((imageInfo.width > limitCreateImageSize ||
      imageInfo.height > limitCreateImageSize) &&
      cropInfo.angle) ||
    (!cropInfo.angle &&
      (cropInfo.rect[2] > limitCreateImageSize ||
        cropInfo.rect[3] > limitCreateImageSize));
  if (limitCreateImageSize && isOverLimit) {
    repeatCount = everyRepeatLimitSizeList.findIndex(
      (v) => v == limitCreateImageSize
    );
    if (repeatCount > -1) {
      let scale = scaleList[repeatCount] || 0.5;
      let scaleImageSrc = await mwx.useCompressImage({
        imageSrc: originalImageSrc,
        quality: 100,
        maxWidth: imageInfo.width * scale,
        maxHeight: imageInfo.height * scale
      });
      // await mwx.saveImageToPhotosAlbum({ filePath: scaleImageSrc });
      let compressImageInfo = await mwx.getImageInfo(scaleImageSrc);
      mwx.log.info(
        `crop预压缩处理:width=${compressImageInfo.width},height=${compressImageInfo.height},limitCreateImageSize=${limitCreateImageSize}`
      );
      let compressScale = compressImageInfo.width / imageInfo.width;
      //
      return cropHandler({
        imageSrc: scaleImageSrc,
        cropInfo,
        repeatCount: repeatCount + 1,
        scale: compressScale,
        pageSelf
      });
    }
  }

  async function cropHandler({
    imageSrc,
    cropInfo,
    repeatCount = 0,
    scale = 1
  }) {
    cropInfo.angle = 0;
    // let fn = cropInfo.angle ? _cropRotate : _crop;
    let fn = _crop;
    let r = await fn({
      imageSrc,
      cropInfo,
      scale,
      originImageWidth,
      originImageHeight
    });
    let isTransparent = false;
    let condition =
      isTransparent && repeatCount < scaleList.length && scale <= 1;

    mwx.log.info(
      `crop:condition=${condition},isTransparent=${isTransparent},repeatCount=${repeatCount},scale=${scale}`
    );
    if (condition) {
      scale = scaleList[repeatCount] || 0.5;
      mwx.log.info(`crop:repeatCount=${repeatCount},scale=${scale}`);
      //
      let scaleImageSrc = await mwx.useCompressImage({
        imageSrc: originalImageSrc,
        maxWidth: imageInfo.width * scale,
        maxHeight: imageInfo.height * scale
      });
      let compressImageInfo = await mwx.getImageInfo(scaleImageSrc);
      let compressScale = compressImageInfo.width / imageInfo.width;
      mwx.log.info(
        `crop after compress:scale=${scale},compressScale=${compressScale},compressImageInfo=${JSON.stringify(
          compressImageInfo
        )},imageInfo=${JSON.stringify(imageInfo)}`
      );
      return cropHandler({
        imageSrc: scaleImageSrc,
        cropInfo,
        repeatCount: repeatCount + 1,
        scale: compressScale
      });
    } else {
      return r;
    }
  }
  return cropHandler({ imageSrc, cropInfo, repeatCount: 0, pageSelf });
}

async function _crop({
  imageSrc,
  cropInfo = {},
  scale = 1,
  originImageWidth,
  originImageHeight
}) {
  mwx.log.info('[_crop start]');
  // mwx.saveImageToPhotosAlbum({ filePath: imageSrc });
  let startX = Math.floor(cropInfo.rect[0] * scale);
  let startY = Math.floor(cropInfo.rect[1] * scale);
  let canvasWidth = Math.floor(cropInfo.rect[2] * scale);
  let canvasHeight = Math.floor(cropInfo.rect[3] * scale);
  mwx.log.info(
    `crop:scale=${scale},cropInfo=${JSON.stringify(
      cropInfo
    )},canvasWidth=${canvasWidth},canvasHeight=${canvasHeight}`
  );

  var canvas = document.createElement('canvas');
  var context = canvas.getContext('2d');
  var dpr = 1 || window.devicePixelRatio; // 获取设备像素比
  canvas.width = canvasWidth * dpr;
  canvas.height = canvasHeight * dpr;
  canvas.style.width = canvasWidth + 'px';
  canvas.style.height = canvasHeight + 'px';
  context.scale(dpr, dpr); // 缩放上下文以匹配分辨率

  //   canvas
  context.clearRect(0, 0, canvasWidth, canvasHeight);
  let handleImage = await createImage(imageSrc);
  // cropInfo.angle = 180;

  context.drawImage(
    handleImage,
    startX,
    startY,
    canvasWidth,
    canvasHeight,
    0,
    0,
    canvasWidth,
    canvasHeight
  );
  let r = canvas.toDataURL('image/jpeg');
  canvas = null;
  context = null;
  return r;
}

async function createSingleCard({
  imageSrc, // 图片地址(抠好的图片)
  canvasWidth, // 图片的宽高
  canvasHeight,
  text,
  type,
  colorInfo,
  destWidth,
  destHeight,
  fontSize = 16,
  textBoxHeight = 24,
  fontSizeScale,
  textBoxHeightScale,
  pageSelf
}) {
  console.log('createSingleCard start', arguments);
  let imageInfo = await mwx.getImageInfo(imageSrc);
  let max = Math.max(imageInfo.width, imageInfo.height);
  let scaleList = everyRepeatLimitSizeList
    .map((v) => v / max)
    .filter((v) => v <= 1);
  let originalImageSrc = imageSrc;
  let self = this;

  // let limitCreateImageSize = mwx.Store.get('limitCreateImageSize');
  let limitCreateImageSize = 0;
  let repeatCount = 0;
  // canvas最大画布为4096，dpr*canvasWidth<=4096
  let maxDrawImageSize = maxCanvasWidth;
  if (
    !limitCreateImageSize &&
    (imageInfo.width > maxDrawImageSize || imageInfo.height > maxDrawImageSize)
  ) {
    limitCreateImageSize = everyRepeatLimitSizeList[0];
  }
  if (
    limitCreateImageSize &&
    (imageInfo.width > limitCreateImageSize ||
      imageInfo.height > limitCreateImageSize)
  ) {
    repeatCount = everyRepeatLimitSizeList.findIndex(
      (v) => v == limitCreateImageSize
    );
    if (repeatCount > -1) {
      let scale = scaleList[repeatCount] || 0.5;
      let scaleImageSrc = await mwx.useCompressImage({
        imageSrc: originalImageSrc,
        maxWidth: imageInfo.width * scale,
        maxHeight: imageInfo.height * scale
      });
      let compressImageInfo = await mwx.getImageInfo(scaleImageSrc);
      canvasWidth = compressImageInfo.width;
      canvasHeight = compressImageInfo.height;

      mwx.log.info(
        `createSingleCard预压缩处理:canvasWidth=${canvasWidth},canvasHeight=${canvasHeight}`
      );
      return handler({
        imageSrc: scaleImageSrc,
        canvasWidth,
        canvasHeight,
        repeatCount: repeatCount + 1,
        pageSelf
      });
    }
  }

  async function handler({
    imageSrc,
    canvasWidth,
    canvasHeight,
    repeatCount = 0,
    pageSelf
  }) {
    let r = await _createSingleCard({
      imageSrc,
      canvasWidth,
      canvasHeight,
      text,
      type,
      colorInfo,
      destWidth,
      destHeight,
      fontSize,
      textBoxHeight,
      fontSizeScale,
      textBoxHeightScale
    });
    let isTransparent = false;
    let scale = scaleList[repeatCount] || 0.5;
    let condition =
      isTransparent && repeatCount < scaleList.length && scale <= 1;

    mwx.log.info(
      `createSingleCard:condition=${condition},isTransparent=${isTransparent},repeatCount=${repeatCount},scale=${scale},scaleList=${JSON.stringify(
        scaleList
      )}`
    );
    // condition = repeatCount < 2 && scale <= 1;
    if (condition) {
      scale = scaleList[repeatCount] || 0.5;
      let scaleImageSrc = await mwx.useCompressImage({
        imageSrc: originalImageSrc,
        maxWidth: imageInfo.width * scale,
        maxHeight: imageInfo.height * scale
      });
      let compressImageInfo = await mwx.getImageInfo(scaleImageSrc);
      canvasWidth = compressImageInfo.width;
      canvasHeight = compressImageInfo.height;

      mwx.log.info(
        `createSingleCard:canvasWidth=${canvasWidth},canvasHeight=${canvasHeight}`
      );
      return handler({
        imageSrc: scaleImageSrc,
        canvasWidth,
        canvasHeight,
        repeatCount: repeatCount + 1,
        pageSelf
      });
    } else {
      return r;
    }
  }
  return handler({
    imageSrc,
    canvasWidth,
    canvasHeight,
    repeatCount: 0,
    pageSelf
  });
}

async function _createSingleCard({
  imageSrc,
  canvasWidth,
  canvasHeight,
  text,
  type,
  colorInfo,
  destWidth,
  destHeight,
  fontSize = 16,
  textBoxHeight = 24,
  fontSizeScale,
  textBoxHeightScale
}) {
  let imageWidth = canvasWidth;
  let imageHeight = canvasHeight;
  let dpr = 1;
  // let dpr = getApp().globalData.systemInfo.pixelRatio;
  if (destWidth) {
    canvasWidth = destWidth;
    canvasHeight = destHeight;
    mwx.log.info('dpr', dpr, imageWidth / canvasWidth);
    dpr = imageWidth / canvasWidth;
  }
  // mwx.log.info(
  //   `_createSingleCard: canvasWidth=${canvasWidth},canvasHeight=${canvasHeight},imageSrc=${imageSrc},type=${type},colorInfo=${JSON.stringify(
  //     colorInfo
  //   )},destWidth=${destWidth},destHeight=${destHeight}`
  // );

  let cardWidth = canvasWidth;
  let cardHeight = canvasHeight;
  if (fontSizeScale) {
    fontSize = canvasWidth * fontSizeScale;
    textBoxHeight = canvasWidth * textBoxHeightScale;
  }
  let { context, canvas } = await initCanvas({
    canvasWidth,
    canvasHeight,
    dpr
  });
  context.clearRect(0, 0, canvasWidth, canvasHeight);
  let ctx = context;
  if (colorInfo && (colorInfo.colorImgUr || colorInfo.color)) {
    if (colorInfo.gradient) {
      const gradient = ctx.createLinearGradient(0, 0, 0, cardHeight);
      gradient.addColorStop(0, colorInfo.startColor); // 顶部颜色
      gradient.addColorStop(1, colorInfo.endColor); // 底部颜色
      // 应用渐变色填充矩形
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, cardWidth, cardHeight);
    } else if (colorInfo.useOriginImageAsBg) {
      // 使用原图作为背景,不需要绘制背景
    } else {
      ctx.fillStyle = colorInfo.color;
      ctx.fillRect(0, 0, cardWidth, cardHeight);
    }
  }
  let img = await createImage(imageSrc);

  ctx.drawImage(
    img,
    0,
    0,
    imageWidth,
    imageHeight,
    0,
    0,
    cardWidth,
    cardHeight
  );
  if (text) {
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, cardHeight - textBoxHeight, cardWidth, textBoxHeight);
    ctx.fillStyle = '#222';
    ctx.font = `${fontSize}px Arial bold`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(text, cardWidth / 2, cardHeight - textBoxHeight / 2);
  }

  if (type == 'preview') {
    let px2rpx = getApp().globalData.px2rpx;
    let ratio = cardWidth / 295;
    let prevImageSize = (136 / px2rpx) * ratio;
    let prevImageOffset = (-12 / px2rpx) * ratio;
    let prevMarkImg = await createImage(
      require('@/assets/image/id_certificate_icon_previewmark@2x.png')
    );
    ctx.drawImage(
      prevMarkImg,
      cardWidth - (prevImageSize + prevImageOffset),
      cardHeight - (prevImageSize + prevImageOffset),
      prevImageSize,
      prevImageSize
    );
  }
  let config = {
    x: 0,
    y: 0,
    width: canvasWidth,
    height: canvasHeight,
    canvas,
    fileType: 'jpg'
  };
  if (destWidth) {
    config.destWidth = destWidth;
    config.destHeight = destHeight;
  }
  let result = canvas.toDataURL('image/jpeg');
  if (destWidth) {
    result = await mwx.useCompressImage({
      imageSrc: result,
      maxWidth: destWidth,
      maxHeight: destHeight,
      specifiedWidth: destWidth,
      specifiedHeight: destHeight
    });
  }
  result = changeDpiDataUrl(result, 300);
  mwx.log.info('[_createSingleCard end]');
  return result;
}

async function adjustPosition({
  imageSrc,
  width,
  height,
  offsetTop,
  leftSpaceWidth,
  rightSpaceWidth
}) {
  let maxCanvasSize = maxCanvasWidth;
  let canvasWidth = width;
  let canvasHeight = height;
  let originImageWidth = width;
  let originImageHeight = height;
  // 如果大于1365尺寸，缩放到1365
  let scale = 1;
  if (width > maxCanvasSize || height > maxCanvasSize) {
    let info = mwx.calcMaxSize(width, height, maxCanvasSize, maxCanvasSize);
    canvasWidth = info.width;
    canvasHeight = info.height;
    scale = canvasWidth / width;
  }

  let res = initCanvas({ dpr: 1, canvasWidth, canvasHeight });
  let ctx = res.context;
  let canvas = res.canvas;
  let image = await createImage(imageSrc);
  // 判断图片左右是否有空白区域
  if (leftSpaceWidth || rightSpaceWidth) {
    // 计算去除左右空白区域之后的宽高
    let afterCropWidth = originImageWidth - leftSpaceWidth - rightSpaceWidth;
    let afterCropHeight =
      afterCropWidth / (originImageWidth / originImageHeight);
    let y = originImageHeight - afterCropHeight + offsetTop;

    ctx.drawImage(
      image,
      leftSpaceWidth,
      0,
      afterCropWidth,
      afterCropHeight,
      0,
      y,
      canvasWidth,
      canvasHeight
    );
  } else {
    ctx.drawImage(
      image,
      0,
      0,
      originImageWidth,
      originImageHeight,
      0,
      offsetTop,
      canvasWidth,
      canvasHeight
    );
  }
  let r = canvas.toDataURL('image/png');
  if (canvasWidth) {
    r = await mwx.useCompressImage({
      imageSrc: r,
      specifiedWidth: canvasWidth,
      specifiedHeight: canvasHeight,
      imageType: 'png'
    });
  }
  canvas = null;
  ctx = null;
  return r;
}

async function rotateImage(opt) {
  let rotateStateTime = new Date().getTime();
  let imageType = (await mwx.getImageInfo(opt.imageSrc)) || 'jpeg';
  // console.log('rotateImage', opt);
  let { canvasWidth, canvasHeight, imageSrc } = opt;
  if (!opt.repeatCount) {
    opt.repeatCount = 1;
  }
  let { context: ctx, canvas } = await initCanvas({
    canvasWidth,
    canvasHeight,
    dpr: 1
  });
  let canvasImage = await createImage(imageSrc);
  let imageInfo = await mwx.getImageInfo(imageSrc);
  if (opt.rotate !== undefined) {
    ctx.save();
    ctx.translate(canvasWidth / 2, canvasHeight / 2);
    ctx.rotate((opt.rotate / 180) * Math.PI);
    if (opt.rotate % 180 == 0) {
      ctx.drawImage(
        canvasImage,
        0,
        0,
        imageInfo.width,
        imageInfo.height,
        -canvasWidth / 2,
        -canvasHeight / 2,
        canvasWidth,
        canvasHeight
      );
    } else {
      ctx.drawImage(
        canvasImage,
        0,
        0,
        imageInfo.width,
        imageInfo.height,
        -canvasHeight / 2,
        -canvasWidth / 2,
        canvasHeight,
        canvasWidth
      );
    }
    ctx.restore();
  } else {
    ctx.drawImage(
      canvasImage,
      0,
      0,
      imageInfo.width,
      imageInfo.height,
      0,
      0,
      canvasWidth,
      canvasHeight
    );
  }

  let r;
  r = canvas.toDataURL(`image/${opt.fileType || imageType}`, 0.9);
  // console.log('---旋转前', Math.round(opt.imageSrc.length / 1024 / 1024));
  // console.log('---旋转后', Math.round(r.length / 1024 / 1024));
  // if (opt.repeatCount == 1) {
  //   r = 'data:,';
  //
  // }
  // console.log('旋转耗时', new Date().getTime() - rotateStateTime + 'ms');
  if (r == 'data:,') {
    console.log('rotateImage data fail', opt.repeatCount);
    if (opt.repeatCount < 4) {
      return rotateImage({
        ...opt,
        canvasWidth: canvasWidth * 0.8,
        canvasHeight: canvasHeight * 0.8,
        imageSrc,
        repeatCount: opt.repeatCount + 1
      });
    } else {
      throw new Error(mwx.failReasonMap.rotateFail);
    }
    // return imageSrc;
  }
  // console.log('rotate finish');

  ctx = null;
  canvas = null;
  return r;
}

// 根据图片宽高比和模板的宽高比，计算图片在canvas中的位置和大小
async function cropPhoto({
  imageSrc,
  maxCanvasSize = 3000,
  template,
  centerPoint
}) {
  let photoSizeInfo = mwx.getPhotoSizeInfo(template);
  // 这里宽高对调了，photoSizeInfo.width对应canvasHeight，并且不能超过canvas的maxCanvasSize限制
  let canvasHeight = Math.min(maxCanvasSize, photoSizeInfo.height);
  // photoSizeInfo的宽大于高，canvasWidth不能担心超过maxCanvasSize
  let canvasWidth = canvasHeight / photoSizeInfo.ratio;
  let imageInfo = await createImage(imageSrc);
  let imageRatio = imageInfo.width / imageInfo.height;
  let canvasRatio = canvasWidth / canvasHeight;
  let inCanvasImageWidth;
  let inCanvasImageHeight;

  // 图片短的一边撑满canvas
  if (imageRatio > canvasRatio) {
    inCanvasImageHeight = canvasHeight;
    inCanvasImageWidth = inCanvasImageHeight * imageRatio;
  } else {
    inCanvasImageWidth = canvasWidth;
    inCanvasImageHeight = inCanvasImageWidth / imageRatio;
  }
  let imageToCanvasRatio = inCanvasImageWidth / imageInfo.width; // 图片在canvas中的宽度和原图宽度的比例
  let cropImageInfo = {
    x: (canvasWidth - inCanvasImageWidth) / 2,
    y: (canvasHeight - inCanvasImageHeight) / 2,
    width: inCanvasImageWidth,
    height: inCanvasImageHeight
  };

  // ai裁剪返回的中心坐标

  if (centerPoint) {
    // ai裁剪返回的中心坐标和图片中心坐标的差值, 乘以imageToCanvasRatio,转换以canvas为基准的坐标
    let centerDiff = {
      x: (centerPoint.x - imageInfo.width / 2) * imageToCanvasRatio,
      y: (centerPoint.y - imageInfo.height / 2) * imageToCanvasRatio
    };
    if (inCanvasImageWidth == canvasWidth) {
      cropImageInfo = {
        ...cropImageInfo,
        y:
          cropImageInfo.y -
          Math.min(centerDiff.y, -(canvasHeight - inCanvasImageHeight) / 2)
      };
    } else {
      cropImageInfo = {
        ...cropImageInfo,
        x:
          cropImageInfo.x -
          Math.min(centerDiff.x, -(canvasWidth - inCanvasImageWidth) / 2)
      };
    }
  }

  return {
    imageSrc,
    canvasWidth,
    canvasHeight,
    imageInfo: cropImageInfo,
    layoutType: 'fill',
    whiteBorder: 0
  };
}

async function clipPhoto({
  canvasWidth,
  canvasHeight,
  imageSrc,
  drawCanvasInfo,
  maxCanvasSize = 3000
}) {
  let exportScale =
    drawCanvasInfo.baseType == 'width'
      ? Math.min(drawCanvasInfo.originImageWidth, maxCanvasSize) / canvasWidth
      : Math.min(drawCanvasInfo.originImageHeight, maxCanvasSize) /
        canvasHeight;

  let { context: ctx, canvas } = await initCanvas({
    canvasWidth: canvasWidth * exportScale,
    canvasHeight: canvasHeight * exportScale,
    dpr: 1
  });
  console.log(
    'clipPhoto',
    canvasWidth,
    canvasHeight,
    exportScale,
    canvas.width,
    canvas.height
  );
  ctx.fillStyle = 'white';
  ctx.scale(exportScale, exportScale);
  let img = await createImage(imageSrc);
  ctx.fillStyle = 'white';
  ctx.fillRect(0, 0, canvasWidth, canvasHeight);
  if (drawCanvasInfo.whiteBorder) {
    // whiteBorder以左右留白为基准,
    // 计算有白边的图片在canvas中的宽度
    let withBorderImageWidth =
      drawCanvasInfo.inCanvasImageWidth - drawCanvasInfo.whiteBorder * 2;
    let withBorderImageHeight =
      drawCanvasInfo.inCanvasImageHeight - drawCanvasInfo.whiteBorder * 2;
    let verticalWhiteBorder = drawCanvasInfo.whiteBorder;

    ctx.drawImage(
      img,
      drawCanvasInfo.currStatus.x + drawCanvasInfo.whiteBorder,
      drawCanvasInfo.currStatus.y + verticalWhiteBorder,
      withBorderImageWidth,
      withBorderImageHeight
    );
    // 绘制白边
    ctx.fillStyle = 'white';
    // 顶部部白边
    ctx.fillRect(0, 0, canvasWidth, verticalWhiteBorder);
    // 底部白边
    ctx.fillRect(
      0,
      canvasHeight - verticalWhiteBorder,
      canvasWidth,
      verticalWhiteBorder
    );
    // 左边的白边
    ctx.fillRect(0, 0, drawCanvasInfo.whiteBorder, canvasHeight);
    // 右边的白边
    ctx.fillRect(
      canvasWidth - drawCanvasInfo.whiteBorder,
      0,
      drawCanvasInfo.whiteBorder,
      canvasHeight
    );
  } else {
    ctx.drawImage(
      img,
      drawCanvasInfo.currStatus.x,
      drawCanvasInfo.currStatus.y,
      drawCanvasInfo.inCanvasImageWidth,
      drawCanvasInfo.inCanvasImageHeight
    );
  }
  let r = canvas.toDataURL('image/jpeg', 0.92);
  if (r == 'data:,') {
    console.error('clipPhoto data fail');
    window.__maxCanvasSize = Math.max(Math.floor(maxCanvasSize / 2), 1000);
    return clipPhoto({
      canvasWidth,
      canvasHeight,
      imageSrc,
      drawCanvasInfo,
      maxCanvasSize: window.__maxCanvasSize
    });
  }
  // mwx.downloadFile(r);
  ctx = null;
  canvas = null;
  return r;
}

// 从图片中裁剪出指定坐标大小的区域图片
async function cropImage({
  imageSrc,
  imageToCanvasRatio = 1, // 默认比例设为1，允许动态调整
  maxRetry = 3, // 最大重试次数
  currentRetry = 0, // 当前重试次数
  x,
  y,
  width,
  height
}) {
  try {
    // 动态计算当前比例（每次重试缩小一半）
    const currentRatio = imageToCanvasRatio * Math.pow(0.5, currentRetry);

    // 初始化 Canvas
    const canvasWidth = width * currentRatio;
    const canvasHeight = height * currentRatio;
    const { context, canvas } = await initCanvas({ canvasWidth, canvasHeight });

    // 绘制图像
    const handleImage = await createImage(imageSrc);
    context.clearRect(0, 0, canvasWidth, canvasHeight);
    context.drawImage(
      handleImage,
      x * imageToCanvasRatio,
      y * imageToCanvasRatio,
      width * imageToCanvasRatio,
      height * imageToCanvasRatio,
      0,
      0,
      canvasWidth,
      canvasHeight
    );

    // 导出检测
    const dataURL = canvas.toDataURL('image/png', 0.8);
    if (dataURL === 'data:,') {
      if (currentRetry < maxRetry) {
        console.warn(`导出失败，尝试缩小比例重试 (第${currentRetry + 1}次)`);
        return cropImage({
          imageSrc,
          imageToCanvasRatio,
          maxRetry,
          currentRetry: currentRetry + 1,
          x,
          y,
          width,
          height
        });
      } else {
        throw new Error('达到最大重试次数仍无法导出有效数据');
      }
    }
    return dataURL;
  } catch (error) {
    console.error('裁剪失败:', error);
    throw error; // 向上抛出异常
  }
}

function handleRemainMain({ canvas, imageData }) {
  let startTime = new Date().getTime();
  const data = imageData.data;

  // 标记图形
  const labels = new Uint32Array(canvas.width * canvas.height).fill(0);
  let currentLabel = 1;
  const areas = new Map();

  // 辅助函数：获取像素索引
  function getIndex(x, y) {
    return (y * canvas.width + x) * 4;
  }

  // 辅助函数：检查是否透明
  function isTransparent(x, y) {
    const alpha = data[getIndex(x, y) + 3];
    return alpha === 0;
  }

  // 洪水填充算法
  function floodFill(x, y, label) {
    const stack = [[x, y]];
    let area = 0;

    while (stack.length > 0) {
      const [cx, cy] = stack.pop();
      const idx = cy * canvas.width + cx;

      if (
        cx < 0 ||
        cx >= canvas.width ||
        cy < 0 ||
        cy >= canvas.height ||
        labels[idx] > 0 ||
        isTransparent(cx, cy)
      ) {
        continue;
      }

      labels[idx] = label;
      area++;
      // 周围8个像素点检测
      stack.push([cx + 1, cy]);
      stack.push([cx - 1, cy]);
      stack.push([cx, cy + 1]);
      stack.push([cx, cy - 1]);

      stack.push([cx - 1, cy + 1]);
      stack.push([cx + 1, cy + 1]);
      stack.push([cx + 1, cy - 1]);
      stack.push([cx - 1, cy - 1]);
    }

    return area;
  }

  // 遍历像素，标记所有非透明区域
  for (let y = 0; y < canvas.height; y++) {
    for (let x = 0; x < canvas.width; x++) {
      const idx = y * canvas.width + x;
      if (!isTransparent(x, y) && labels[idx] === 0) {
        const area = floodFill(x, y, currentLabel);
        areas.set(currentLabel, area);
        currentLabel++;
      }
    }
  }

  // 找出最大区域
  let maxArea = 0;
  let maxLabel = 0;
  areas.forEach((area, label) => {
    if (area > maxArea) {
      maxArea = area;
      maxLabel = label;
    }
  });

  // 清理画布，仅保留最大区域
  for (let y = 0; y < canvas.height; y++) {
    for (let x = 0; x < canvas.width; x++) {
      const idx = y * canvas.width + x;
      if (labels[idx] !== maxLabel) {
        data[getIndex(x, y) + 3] = 0; // 设置为透明
      }
    }
  }
  console.log('remainMain耗时', new Date().getTime() - startTime + 'ms');
  return imageData;
}

async function removeImageAroundTransparent({
  imageSrc,
  isOutputImage,
  times = 0,
  remainMain = true
}) {
  let limitSize = 999999;
  let imageInfo = await mwx.getImageInfo(imageSrc);
  let canvasWidth = imageInfo.width;
  let canvasHeight = imageInfo.height;
  let scale = 1;
  // if (imageInfo.width > limitSize || imageInfo.height > limitSize) {
  //   let info = mwx.calcMaxSize(
  //     imageInfo.width,
  //     imageInfo.height,
  //     limitSize,
  //     limitSize
  //   );
  //   canvasWidth = info.width;
  //   canvasHeight = info.height;
  //   scale = info.width / imageInfo.width;
  // }
  let dpr = window.devicePixelRatio || 1;
  dpr = 1;
  let { context, canvas } = await initCanvas({
    canvasWidth,
    canvasHeight,
    dpr
  });

  context.clearRect(0, 0, canvasWidth, canvasHeight);
  let handleImage = await createImage(imageSrc);
  context.drawImage(
    handleImage,
    0,
    0,
    imageInfo.width,
    imageInfo.height,
    0,
    0,
    canvasWidth,
    canvasHeight
  );

  let res = await context.getImageData(
    0,
    0,
    canvasWidth * dpr,
    canvasHeight * dpr
  );
  if (remainMain) {
    res = handleRemainMain({ canvas, imageData: res });
  }
  context.putImageData(res, 0, 0);

  function scanLeft(imageData) {
    let leftWidth = 0; // 左侧透明宽度
    for (let j = 0; j < imageData.width; j++) {
      // 判断是否垂直透明的线
      let isTransparentLine = true;
      for (let i = 0; i < imageData.height; i++) {
        let index = (i * imageData.width + j) * 4;
        if (imageData.data[index + 3] != 0) {
          isTransparentLine = false;
        }
      }
      if (isTransparentLine) {
        leftWidth++;
      } else {
        return leftWidth;
      }
    }
    return leftWidth;
  }
  function scanRight(imageData) {
    let rightWidth = 0; // 右侧透明宽度
    for (let j = imageData.width - 1; j >= 0; j--) {
      // 判断是否垂直透明的线
      let isTransparentLine = true;
      for (let i = 0; i < imageData.height; i++) {
        let index = (i * imageData.width + j) * 4;
        if (imageData.data[index + 3] != 0) {
          isTransparentLine = false;
        }
      }
      if (isTransparentLine) {
        rightWidth++;
      } else {
        return rightWidth;
      }
    }
    return rightWidth;
  }
  function scanTop(imageData) {
    let top = 0; // 左侧透明宽度
    for (let j = 0; j < imageData.height; j++) {
      // 判断是否垂直透明的线
      let isTransparentLine = true;
      for (let i = 0; i < imageData.width; i++) {
        let index = (j * imageData.width + i) * 4;
        if (imageData.data[index + 3] != 0) {
          isTransparentLine = false;
        }
      }
      if (isTransparentLine) {
        top++;
      } else {
        return top;
      }
    }
    return top;
  }
  function scanBottom(imageData) {
    let bottom = 0; // 右侧透明宽度
    for (let j = imageData.height - 1; j >= 0; j--) {
      // 判断是否垂直透明的线
      let isTransparentLine = true;
      for (let i = 0; i < imageData.width; i++) {
        let index = (j * imageData.width + i) * 4;
        if (imageData.data[index + 3] != 0) {
          isTransparentLine = false;
        }
      }
      if (isTransparentLine) {
        bottom++;
      } else {
        return bottom;
      }
    }
    return bottom;
  }

  let leftWidth = scanLeft(res) / dpr;
  let rightWidth = scanRight(res) / dpr;
  let topWidth = scanTop(res) / dpr;
  let bottomWidth = scanBottom(res) / dpr;
  let offset = Math.min.apply([], [leftWidth, topWidth, 30]);
  offset = 0;

  let src = '';
  let x = leftWidth - offset;
  let y = topWidth - offset;
  let width = canvasWidth - leftWidth - rightWidth + offset * 2;
  let height = canvasHeight - topWidth - bottomWidth + offset * 2;
  if (isOutputImage) {
    let { canvas: exportCanvas, context: exportContext } = initCanvas({
      canvasWidth: width,
      canvasHeight: height,
      dpr: 1
    });
    exportContext.drawImage(canvas, x, y, width, height, 0, 0, width, height);
    src = exportCanvas.toDataURL('image/png');
  }
  let percent = await service.checkImageTransparentPercent(src);
  if (percent >= 99) {
    if (times <= 3) {
      // 透明图片
      times++;
      return removeImageAroundTransparent({
        imageSrc,
        isOutputImage,
        limitSize: limitSize * 0.8,
        times
      });
    }
  }

  // console.log('去除透明', leftWidth / scale, topWidth / scale);
  if (!width || !height || percent >= 99) {
    mwx.log.info('removeImageAroundTransparent 全部透明 imageSrc:' + imageSrc);
    return {
      imageInfo,
      src: imageSrc,
      leftWidth: 0,
      rightWidth: 0,
      topWidth: 0,
      bottomWidth: 0,
      scale: 1,
      noCrop: true
    };
  }
  return {
    imageInfo,
    src,
    leftWidth: leftWidth / scale,
    rightWidth: rightWidth / scale,
    topWidth: topWidth / scale,
    bottomWidth: bottomWidth / scale,
    scale: dpr,
    destWidth: (canvasWidth - leftWidth - rightWidth + offset * 2) / scale,
    destHeight: (canvasHeight - topWidth - bottomWidth + offset * 2) / scale
  };
}

function isWhite(data, index) {
  if (
    data[index] == 255 &&
    data[index + 1] == 255 &&
    data[index + 2] == 255 &&
    data[index + 3] == 255
  ) {
    return true;
  } else {
    return false;
  }
}

async function removeImageAroundWhite({
  imageSrc,
  isOutputImage = true,
  limitSize = 3000,
  beforeHook
}) {
  // return { src: imageSrc };
  let imageInfo = await mwx.getImageInfo(imageSrc);
  let canvasWidth = imageInfo.width;
  let canvasHeight = imageInfo.height;
  let scale = 1;
  let startTime = new Date().getTime();
  if (imageInfo.width > limitSize || imageInfo.height > limitSize) {
    let info = mwx.calcMaxSize(
      imageInfo.width,
      imageInfo.height,
      limitSize,
      limitSize
    );
    canvasWidth = info.width;
    canvasHeight = info.height;
    scale = info.width / imageInfo.width;
  }
  let dpr = window.devicePixelRatio || 1;
  dpr = 1;
  let { context, canvas } = await initCanvas({
    canvasWidth,
    canvasHeight,
    dpr
  });

  context.clearRect(0, 0, canvasWidth, canvasHeight);
  let handleImage = await createImage(imageSrc);
  context.drawImage(
    handleImage,
    0,
    0,
    imageInfo.width,
    imageInfo.height,
    0,
    0,
    canvasWidth,
    canvasHeight
  );

  let res = await context.getImageData(
    0,
    0,
    canvasWidth * dpr,
    canvasHeight * dpr
  );
  console.log('res', res);
  context.putImageData(res, 0, 0);

  function scanLeft(imageData) {
    let leftWidth = 0; // 左侧透明宽度
    for (let j = 0; j < imageData.width; j++) {
      // 判断是否垂直透明的线
      let isTransparentLine = true;
      for (let i = 0; i < imageData.height; i++) {
        let index = (i * imageData.width + j) * 4;
        if (!isWhite(imageData.data, index)) {
          isTransparentLine = false;
        }
      }
      if (isTransparentLine) {
        leftWidth++;
      } else {
        return leftWidth;
      }
    }
    return leftWidth;
  }
  function scanRight(imageData) {
    let rightWidth = 0; // 右侧透明宽度
    for (let j = imageData.width - 1; j >= 0; j--) {
      // 判断是否垂直透明的线
      let isTransparentLine = true;
      for (let i = 0; i < imageData.height; i++) {
        let index = (i * imageData.width + j) * 4;
        if (!isWhite(imageData.data, index)) {
          isTransparentLine = false;
        }
      }
      if (isTransparentLine) {
        rightWidth++;
      } else {
        return rightWidth;
      }
    }
    return rightWidth;
  }
  function scanTop(imageData) {
    let top = 0; // 左侧透明宽度
    for (let j = 0; j < imageData.height; j++) {
      // 判断是否垂直透明的线
      let isTransparentLine = true;
      for (let i = 0; i < imageData.width; i++) {
        let index = (j * imageData.width + i) * 4;
        if (!isWhite(imageData.data, index)) {
          isTransparentLine = false;
        }
      }
      if (isTransparentLine) {
        top++;
      } else {
        return top;
      }
    }
    return top;
  }
  function scanBottom(imageData) {
    let bottom = 0; // 右侧透明宽度
    for (let j = imageData.height - 1; j >= 0; j--) {
      // 判断是否垂直透明的线
      let isTransparentLine = true;
      for (let i = 0; i < imageData.width; i++) {
        let index = (j * imageData.width + i) * 4;
        if (!isWhite(imageData.data, index)) {
          isTransparentLine = false;
        }
      }
      if (isTransparentLine) {
        bottom++;
      } else {
        return bottom;
      }
    }
    return bottom;
  }

  let leftWidth = scanLeft(res) / dpr;
  let rightWidth = scanRight(res) / dpr;
  let topWidth = scanTop(res) / dpr;
  let bottomWidth = scanBottom(res) / dpr;
  let offset = 0;

  let x = leftWidth - offset;
  let y = topWidth - offset;
  let width = canvasWidth - leftWidth - rightWidth;
  let height = canvasHeight - topWidth - bottomWidth;
  let { canvas: exportCanvas, context: exportContext } = initCanvas({
    canvasWidth: width,
    canvasHeight: height,
    dpr: 1
  });
  let done = true;
  if (beforeHook) {
    done = beforeHook({ leftWidth, rightWidth, topWidth, bottomWidth });
  }
  exportContext.drawImage(canvas, x, y, width, height, 0, 0, width, height);

  // leftWidth: leftWidth / scale,
  // rightWidth: rightWidth / scale,
  // topWidth: topWidth / scale,
  // bottomWidth: bottomWidth / scale,
  // scale: dpr,
  // destWidth: (canvasWidth - leftWidth - rightWidth + offset * 2) / scale,
  // destHeight: (canvasHeight - topWidth - bottomWidth + offset * 2) / scale
  console.log(
    'removeImageAroundWhite耗时',
    new Date().getTime() - startTime + 'ms'
  );
  if ((!leftWidth && !rightWidth && !topWidth && !bottomWidth) || !done) {
    return imageSrc;
  } else {
    return exportCanvas.toDataURL('image/png', 0.8);
  }
}

let cache = {};

/**
 * 获取图片非透明区域的尺寸信息
 * 分析图片的像素数据，计算非透明像素组成的有效区域的边界和尺寸
 * 支持缓存机制，避免重复计算相同图片
 *
 * @param {string} imageUrl - 图片地址（支持URL或base64格式）
 * @returns {Promise<Object>} 返回非透明区域的尺寸信息
 * @returns {number} returns.width - 非透明区域的宽度
 * @returns {number} returns.height - 非透明区域的高度
 * @returns {number} returns.imageWidth - 原始图片的宽度
 * @returns {number} returns.imageHeight - 原始图片的高度
 *
 * @description
 * 该函数通过以下步骤分析图片的非透明区域：
 * 1. 加载图片并创建Canvas进行像素分析
 * 2. 遍历所有像素，找到alpha通道大于0的像素点
 * 3. 计算非透明像素的最小和最大边界坐标
 * 4. 返回有效区域的尺寸和位置信息
 * 5. 使用缓存机制提高重复调用的性能
 *
 * @example
 * // 基本使用
 * const dimensions = await getNonTransparentDimensions('https://example.com/image.png');
 * console.log(`有效区域尺寸: ${dimensions.width} x ${dimensions.height}`);
 *
 * // 处理base64图片
 * const dimensions = await getNonTransparentDimensions('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAA...');
 *
 * @throws {Error} 当图片加载失败时抛出错误
 */
export async function getNonTransparentDimensions(imageUrl) {
  // 检查缓存，避免重复计算
  if (cache[imageUrl]) {
    return Promise.resolve(cache[imageUrl]);
  }

  return new Promise((resolve, reject) => {
    // 创建图片对象并设置跨域属性
    const img = new Image();
    img.crossOrigin = 'Anonymous';

    img.onload = function () {
      try {
        // 性能优化：计算缩放比例，确保最大尺寸不超过500px
        let scale = 1;
        let processedWidth = img.naturalWidth;
        let processedHeight = img.naturalHeight;

        if (img.naturalWidth > 500 || img.naturalHeight > 500) {
          scale = Math.min(500 / img.naturalWidth, 500 / img.naturalHeight);
          processedWidth = Math.floor(img.naturalWidth * scale);
          processedHeight = Math.floor(img.naturalHeight * scale);
        }

        // 创建Canvas进行像素分析
        const canvas = document.createElement('canvas');
        canvas.width = processedWidth;
        canvas.height = processedHeight;
        const ctx = canvas.getContext('2d');

        // 将图片绘制到Canvas上（可能经过缩放）
        ctx.drawImage(img, 0, 0, processedWidth, processedHeight);

        // 获取像素数据进行分析
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;

        // 初始化边界变量
        let minX = canvas.width;
        let minY = canvas.height;
        let maxX = 0;
        let maxY = 0;

        // 遍历所有像素，寻找非透明像素的边界
        for (let y = 0; y < canvas.height; y++) {
          for (let x = 0; x < canvas.width; x++) {
            const index = (y * canvas.width + x) * 4;
            const alpha = data[index + 3]; // 获取alpha通道值

            // 如果像素不透明（alpha > 0），更新边界坐标
            if (alpha > 0) {
              if (x < minX) minX = x;
              if (x > maxX) maxX = x;
              if (y < minY) minY = y;
              if (y > maxY) maxY = y;
            }
          }
        }

        // 处理全透明图片的情况
        if (minX > maxX || minY > maxY) {
          resolve({
            width: 0,
            height: 0,
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            originalWidth: img.naturalWidth,
            originalHeight: img.naturalHeight,
            processedWidth: processedWidth,
            processedHeight: processedHeight
          });
          return;
        }

        // 计算非透明区域的尺寸（考虑缩放比例）
        let result = {
          width: Math.round(maxX * scale - minX * scale),
          height: Math.round(maxY * scale - minY * scale),
          imageWidth: img.naturalWidth,
          imageHeight: img.naturalHeight
        };

        // 缓存结果并返回
        resolve(result);
        cache[imageUrl] = result;
      } catch (error) {
        reject(error);
      }
    };

    // 处理图片加载失败的情况
    img.onerror = function () {
      reject(new Error('图片加载失败'));
      mwx.log.error(
        'getNonTransparentDimensions:图片加载失败,imageUrl=' + imageUrl
      );
      mwx._getImageErrorCodeInfo(imageUrl);
    };

    // 开始加载图片
    img.src = imageUrl;
  });
}

// 检测透明区域的主函数
async function detectTransparentArea(img) {
  return new Promise((resolve, reject) => {
    try {
      const originalWidth = img.width;
      const originalHeight = img.height;

      // 计算缩放比例，最大边不超过1000px
      const maxDimension = 1000;
      let scaleFactor = 1;
      let scaledWidth, scaledHeight;

      if (originalWidth > originalHeight) {
        scaledWidth = maxDimension;
        scaledHeight = Math.round(
          originalHeight * (maxDimension / originalWidth)
        );
      } else {
        scaledHeight = maxDimension;
        scaledWidth = Math.round(
          originalWidth * (maxDimension / originalHeight)
        );
      }

      // 保存缩放比例
      scaleFactor = originalWidth / scaledWidth;

      // 创建用于检测的Canvas（缩放后）
      const detectCanvas = document.createElement('canvas');
      detectCanvas.width = scaledWidth;
      detectCanvas.height = scaledHeight;

      const detectCtx = detectCanvas.getContext('2d');

      // 绘制图片到检测Canvas（缩放后）
      detectCtx.drawImage(img, 0, 0, scaledWidth, scaledHeight);

      // 获取图像数据
      const imageData = detectCtx.getImageData(0, 0, scaledWidth, scaledHeight);
      const data = imageData.data;

      // 检测四个方向的透明像素（在缩放后的图像上）
      const leftWidthScaled = detectLeftTransparent(
        data,
        scaledWidth,
        scaledHeight
      );
      const rightWidthScaled = detectRightTransparent(
        data,
        scaledWidth,
        scaledHeight
      );
      const topWidthScaled = detectTopTransparent(
        data,
        scaledWidth,
        scaledHeight
      );
      const bottomWidthScaled = detectBottomTransparent(
        data,
        scaledWidth,
        scaledHeight
      );

      // 将检测结果按比例换算回原图尺寸
      const leftWidth = Math.round(leftWidthScaled * scaleFactor);
      const rightWidth = Math.round(rightWidthScaled * scaleFactor);
      const topWidth = Math.round(topWidthScaled * scaleFactor);
      const bottomWidth = Math.round(bottomWidthScaled * scaleFactor);

      // 计算裁剪区域（原图尺寸）
      const cropX = leftWidth;
      const cropY = topWidth;
      const cropWidth = originalWidth - leftWidth - rightWidth;
      const cropHeight = originalHeight - topWidth - bottomWidth;

      // 创建用于最终裁剪的Canvas（原尺寸）
      const resultCanvas = document.createElement('canvas');
      resultCanvas.width = cropWidth;
      resultCanvas.height = cropHeight;

      const resultCtx = resultCanvas.getContext('2d');

      // 绘制裁剪后的图片
      resultCtx.drawImage(
        img,
        cropX,
        cropY,
        cropWidth,
        cropHeight,
        0,
        0,
        cropWidth,
        cropHeight
      );

      // 转换为Blob URL
      resultCanvas.toBlob((blob) => {
        const blobUrl = URL.createObjectURL(blob);

        resolve({
          leftWidth,
          rightWidth,
          topWidth,
          bottomWidth,
          src: blobUrl,
          originalWidth,
          originalHeight,
          scaledWidth,
          scaledHeight,
          destWidth: originalWidth - leftWidth - rightWidth,
          destHeight: originalHeight - topWidth - bottomWidth
        });
      }, 'image/png');
    } catch (error) {
      reject(error);
    }
  });
}

// 检测左侧透明宽度
function detectLeftTransparent(data, width, height) {
  for (let x = 0; x < width; x++) {
    for (let y = 0; y < height; y++) {
      const alpha = data[(y * width + x) * 4 + 3];
      if (alpha > 0) {
        return x;
      }
    }
  }
  return width; // 整个图片都是透明的
}

// 检测右侧透明宽度
function detectRightTransparent(data, width, height) {
  for (let x = width - 1; x >= 0; x--) {
    for (let y = 0; y < height; y++) {
      const alpha = data[(y * width + x) * 4 + 3];
      if (alpha > 0) {
        return width - 1 - x;
      }
    }
  }
  return width; // 整个图片都是透明的
}

// 检测顶部透明宽度
function detectTopTransparent(data, width, height) {
  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      const alpha = data[(y * width + x) * 4 + 3];
      if (alpha > 0) {
        return y;
      }
    }
  }
  return height; // 整个图片都是透明的
}

// 检测底部透明宽度
function detectBottomTransparent(data, width, height) {
  for (let y = height - 1; y >= 0; y--) {
    for (let x = 0; x < width; x++) {
      const alpha = data[(y * width + x) * 4 + 3];
      if (alpha > 0) {
        return height - 1 - y;
      }
    }
  }
  return height; // 整个图片都是透明的
}

export {
  crop,
  createSingleCard,
  createImage,
  adjustPosition,
  rotateImage,
  cropPhoto,
  initCanvas,
  clipPhoto,
  cropImage,
  removeImageAroundTransparent,
  removeImageAroundWhite
};
